export const DoseForecastMode = {
  Count: 'Count',
  All: 'All'
} as const;

export type DoseForecastMode = ValueOf<typeof DoseForecastMode>;

export const DicomDataType = {
  Zip: 'zip',
  Dat: 'dat',
  Zst: 'zst'
} as const;

export type DicomDataType = ValueOf<typeof DicomDataType>;

export const DicomMode = {
  Image: 'image',
  Dose: 'dose',
  Dvf: 'dvf'
} as const;

export type DicomMode = ValueOf<typeof DicomMode>;

export const DicomType = {
  Delivered: 'delivered',
  Accumulated: 'accumulated'
} as const;

export type DicomType = ValueOf<typeof DicomType>;

export const DoseType = {
  Gamma: 'gamma',
  Constraint: 'constraint',
  StructureVolume: 'structure_volume'
} as const;

export type DoseType = ValueOf<typeof DoseType>;

export const TriggerType = {
  Constraint: 'constraint',
  Planning: 'planning',
  AdaptiveDefault: 'adaptive-default'
} as const;

export type TriggerType = ValueOf<typeof TriggerType>;

export const DoseNotificationType = {
  Failures: 'failures',
  Treatments: 'treatments'
} as const;

export type DoseNotificationType = ValueOf<typeof DoseNotificationType>;

export const DvfEditStatusCode = {
  /*
  Requested,
    FailedLoadingDvf,
    FailedLoadingReference,
    FailedGeneratingSyntheticCt,
    FailedGeneratingStructureSetOnCbct,
    FailedGeneratingDoseOnSyntheticCt,
    FailedGeneratingDoseOnPlanningCt,
    FailedDoseToDate,
    FailedAccumulatingDose,
    Succeeded
   */
} as const;

export type DvfEditStatusCode = ValueOf<typeof DvfEditStatusCode>;